export default "__VITE_ASSET__DklOCthp__"